import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Icon, Input } from 'tea-component';

import { getScrollOffset } from '../../utils';
import Tag from './Tag';
import { TagInputProps } from '../type';
import * as styles from './tagSearchInput.module.less'

import { getLocaleText } from '@/pages/home/components/RegionSelect/locale';
import SvgIcon from '../../../SvgIcon';

const TagSearchInput = (props: TagInputProps) => {
  const { data, activeTabId, onDelete, search, panelActive } = props;
  const oInput = useRef(null);
  const oOperation = useRef(null);
  const [operationOffsetTop, setOperationOffsetTop] = useState(0);
  const [active, setActive] = useState(false);
  const [value, setValue] = useState('');
  const [] = useState();
  const hasData = data?.length > 0 || value?.length > 0;

  // 删除事件
  const handleDelete = (id?: string[]) => {
    if (!id) {
      const ids = data?.map((item: any) => item?.id);
      onDelete?.(ids, true);
    } else {
      onDelete?.(id);
    }
    handleSearch('');
  };

  // 激活输入框
  const handleActive = () => {
    const input = oInput?.current as any;
    input?.focus();
    setActive(true);
  };

  // 搜索事件
  const handleSearch = (value: string) => {
    setValue(value);
    search?.(value);
  };

  // 页面点击事件回调
  const clickCallback = (e: any) => {
    const isActive = oInput?.current === document.activeElement;
    setActive(isActive);
  };

  // 回车按下事件回调
  const enterCallback = (e: any) => {
    const keyCode = e.keyCode;

    // 按下回车键触发查询
    if (keyCode === 13) {
      handleSearch(value);
    }
  };

  // 搜索框滚动事件，固定操作按钮居中
  const handleOnScroll = (e: any) => {
    const { y: scrollTop } = getScrollOffset(e?.target);
    const offsetTop = scrollTop;
    setOperationOffsetTop(offsetTop);
  };

  useEffect(() => {
    // 绑定事件
    document.addEventListener('click', clickCallback);
    document.addEventListener('keypress', enterCallback);

    return () => {
      document.removeEventListener('click', clickCallback);
      document.removeEventListener('keypress', enterCallback);
    };
  }, [clickCallback, enterCallback]);

  useEffect(() => {
    // 筛选器面板打开/数据有变，自动触底，并获取焦点
    panelActive && handleActive();
  }, [panelActive, data]);

  // 切换 tab 初始化搜索条件，并重新查询
  useEffect(() => {
    handleSearch('');
  }, [activeTabId]);

  return (
    <div
      className={`
        ${styles['tag-search-input-container']}
        ${(active && styles['active']) || ''}
      `}
      onClick={handleActive}
    >
      <div className={styles['scroll-container']} onScroll={handleOnScroll}>
        <div className={styles['tag-group']}>
          {data?.map((item: any) => (
            <Tag
              key={item.id}
              id={item?.id}
              name={item?.name}
              onDelete={handleDelete}
            />
          ))}
          <div className={styles['search-input-slot']}>
            <Input
              value={value}
              ref={oInput}
              className={styles['search-input']}
              placeholder={data?.length ? '' : getLocaleText('search_text')}
              onChange={handleSearch}
            />
          </div>
        </div>
        <div
          ref={oOperation}
          className={styles['operation-btn']}
          style={{
            top: operationOffsetTop,
          }}
        >
          {hasData ? (
            <div
              className={styles['operation-btn-icon']}
              onClick={() => handleDelete()}
            >
              <SvgIcon
                type="clear-icon"
                className={styles['operation-btn-icon']}
              />
            </div>
          ) : (
            ''
          )}
          <Icon type="search" className={styles['operation-btn-search']} />
        </div>
      </div>
    </div>
  );
};

export default TagSearchInput;
